export default "__VITE_ASSET__D6IOBHHP__"